
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes, NoPreloading } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SearchFilterPipe } from './_shared/filterdata.pipe';
import { GroupByPipe } from './_shared/groupby.pipe';
import { ArraySortPipe } from './_shared/orderby.pipe';
import { ExtendDatePipe } from './_shared/pipes/date.pipe';


const appRoutes: Routes = [
]
@NgModule({
  
  imports: [
    
    FormsModule,
    RouterModule.forChild(appRoutes),
    TranslateModule.forChild({})
  ],
  declarations: [
    SearchFilterPipe,
    GroupByPipe,
    ExtendDatePipe,
    ArraySortPipe
  ],
  exports: [
    TranslateModule,
    SearchFilterPipe,
    ExtendDatePipe,
    GroupByPipe,
    
    ArraySortPipe
  ],
  providers: []
})
export class SharedModule {
  constructor(private translate: TranslateService) {
    translate.addLangs(['en', 'ru']);
    translate.setDefaultLang('en');
    translate.use('en');
  }
}
